import { nanoid } from 'nanoid';

export function handleEpiHiddenInput(input) {
  if (input) {
    input.removeAttribute('autocomplete');
  }
}

export function handleEpiDuplicatedId(section) {
  if (section) {
    const id = `id-${nanoid()}`;
    section.id = id;
  }
}

export function handleEpiRadioGroup(group) {
  if (group) {
    const hasRadio = group._$('input[type="radio"]');
    if (hasRadio) {
      group.setAttribute('role', 'radiogroup');
    }
  }
}

export function handleEpiInputRadio(radio) {
  const id = `id-${nanoid()}`;
  const labelDiv = radio.parentNode;
  const label = labelDiv.querySelector('label');
  const labelParent = labelDiv.parentNode;
  const wrapper = document.createElement('div');
  wrapper.classList.add('FormChoice__Input--Radio-Wrapper');
  labelParent.insertBefore(wrapper, labelDiv);
  wrapper.appendChild(labelDiv);
  wrapper.insertBefore(radio, labelDiv);
  radio.id = id;
  label.htmlFor = id;
}

export function handleEpiInputCheckbox(checkbox) {
  const id = `id-${nanoid()}`;
  const labelDiv = checkbox.parentNode;
  const label = labelDiv.querySelector('label');
  const labelParent = labelDiv.parentNode;
  const wrapper = document.createElement('div');
  wrapper.classList.add('FormChoice__Input--Checkbox-Wrapper');
  labelParent.insertBefore(wrapper, labelDiv);
  wrapper.appendChild(labelDiv);
  wrapper.insertBefore(checkbox, labelDiv);
  checkbox.id = id;
  label.htmlFor = id;
}

export function handleEpiDropdown(dropdown) {
  const wrapper = document.createElement('div');
  wrapper.classList.add('FormSelection__Select-Wrapper');
  dropdown.parentNode.insertBefore(wrapper, dropdown);
  wrapper.appendChild(dropdown);
}

export function handleEpiSimpleInputs(input) {
  input._on('change', handleInput);
  input._on('input', handleInput);
}

function handleInput(e) {
  if (e.target.value) {
    e.target.parentNode.classList.add('Form__Element--Filled');
  } else {
    e.target.parentNode.classList.remove('Form__Element--Filled');
  }
}

export function handleEpiFormSubmit(form) {
  const overlay = document.createElement('div');
  overlay.className = 'EPiServerForms__overlay';
  overlay.innerHTML = `<div aria-label="Submitting form" class="loading">
    <div class="loading__fading-circle">
      <div class="loading__circle"></div>
      <div class="loading__circle loading__circle--2"></div>
      <div class="loading__circle loading__circle--3"></div>
      <div class="loading__circle loading__circle--4"></div>
      <div class="loading__circle loading__circle--5"></div>
      <div class="loading__circle loading__circle--6"></div>
      <div class="loading__circle loading__circle--7"></div>
      <div class="loading__circle loading__circle--8"></div>
      <div class="loading__circle loading__circle--9"></div>
      <div class="loading__circle loading__circle--10"></div>
      <div class="loading__circle loading__circle--11"></div>
      <div class="loading__circle loading__circle--12"></div>
    </div>
  </div>`;
  form.appendChild(overlay);

  const showOverlay = () => overlay.classList.add('EPiServerForms__overlay--visible');
  const hideOverlay = () => overlay.classList.remove('EPiServerForms__overlay--visible');

  // Optimizely (EPiServer) Forms submits via a SYNCHRONOUS XHR from its own
  // submit handler, which freezes the main thread for the whole request. An
  // overlay shown from within that handler never gets painted, so the loader
  // stays invisible. To make it show we intercept the submit click first, paint
  // the overlay, wait two frames so the browser actually renders it, then
  // re-dispatch the click so Optimizely runs its blocking submit with the
  // loader already on screen.
  let submitting = false;
  form.addEventListener(
    'click',
    (e) => {
      const button = e.target.closest('[data-f-type="submitbutton"], .FormSubmitButton');
      if (!button || submitting) return;
      e.preventDefault();
      e.stopImmediatePropagation(); // hold off Optimizely's handler this round
      showOverlay();
      window.requestAnimationFrame(() =>
        window.requestAnimationFrame(() => {
          submitting = true;
          if (window.$$epiforms) {
            // The submit runs asynchronously: Optimizely validates, then a tick
            // later fires `formsStartSubmitting` and runs its blocking XHR. So
            // we can't tell synchronously whether it actually started. Hide via
            // a fail-safe timeout (validation failed -> never starts), cancelled
            // as soon as the submit begins.
            const failSafe = window.setTimeout(hideOverlay, 2000);
            window.$$epiforms(form).one('formsStartSubmitting', () => {
              window.clearTimeout(failSafe);
            });
            button.click();
            submitting = false;
          } else {
            // Local FEE preview: no Optimizely JS, the native submit navigates
            // away and clears the overlay on its own.
            button.click();
            submitting = false;
          }
        })
      );
    },
    true // capture: run before Optimizely's click handler
  );

  // Hide the overlay when Optimizely finishes. It fires these on its OWN jQuery
  // instance (`$$epiforms`), which may not exist yet at DOMContentLoaded (when
  // this runs), so wait for it before binding.
  // Only hide on real completion. `formsNavigateToStep` fires during the
  // progressive submit flow (this button is `data-f-is-progressive-submit`),
  // which would hide the loader right after it appears.
  const bindHideEvents = (jq) => {
    jq(form).on('formsSubmitted formsSubmittedError', hideOverlay);
  };
  if (window.$$epiforms) {
    bindHideEvents(window.$$epiforms);
  } else {
    let attempts = 0;
    const waitForOpti = window.setInterval(() => {
      if (window.$$epiforms) {
        window.clearInterval(waitForOpti);
        bindHideEvents(window.$$epiforms);
      } else if (++attempts > 40) {
        window.clearInterval(waitForOpti); // ~10s: no Optimizely Forms JS
      }
    }, 250);
  }
}
